import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file-earmark-play",
  "use": "icon-file-earmark-play-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" class=\"bi bi-file-earmark-play\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-file-earmark-play\">\r\n  <path d=\"M6 11.117V6.883a.5.5 0 0 1 .757-.429l3.528 2.117a.5.5 0 0 1 0 .858l-3.528 2.117a.5.5 0 0 1-.757-.43z\" />\r\n  <path d=\"M4 0h5.5v1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h1V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z\" />\r\n  <path d=\"M9.5 3V0L14 4.5h-3A1.5 1.5 0 0 1 9.5 3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file-earmark-play.svg
// module id = lB0L
// module chunks = 60